import { Modal } from "bootstrap";
import { FrankenstoriesLogo } from "components/FrankenstoriesLogo";
import { IconText } from "components/IconText";
import { GlobalContext } from "contexts/GlobalContext";
import { useContext, useRef } from "react";
import { createPortal } from "react-dom";
import { Link, useHistory } from "react-router-dom";
import { RouteList } from "Routes";
import { getModalRoot } from "utils/ModalUtils";

export const signUpLogInModalId = "modal-sign-up-log-in";

export const SignUpLogInModal = () => {
    const { signUpModal } = useContext(GlobalContext);

    const modalRef = useRef<HTMLDivElement>(null);

    const title = signUpModal?.title || "Log in or sign up";

    // on route change close modal
    const history = useHistory();

    history.listen(() => {
        if (modalRef.current) {
            const modal = Modal.getOrCreateInstance(modalRef.current);

            modal.hide();
        }
    });

    return createPortal(
        <div ref={modalRef} className="modal fade" id={signUpLogInModalId} title={title}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header bg-dark text-white">
                        <h2 className="h4 flex-grow-1">{title}</h2>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    <div className="modal-body">
                        <FrankenstoriesLogo type="Surprised" hideText={true} />
                    </div>

                    <div className="modal-footer justify-content-center">
                        <Link to={RouteList.SignupTeacher} className="btn btn-primary icon-link">
                            <IconText icon="fas fa-user-plus" text="Sign up" />
                        </Link>

                        <Link to={RouteList.Login} className="btn btn-dark icon-link">
                            <IconText icon="fas fa-sign-in-alt" text="Log in" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>,
        getModalRoot(),
    );
};
